import { NgClass, NgFor, NgIf, NgSwitch, NgSwitchCase, NgSwitchDefault } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';

import { MdbButtonModule, MdbModalRef, MdbModalService, MdbSelectModule, MdbTabsModule } from 'mdb5-adapted';
// import { ToastrService } from 'ngx-toastr';
import { MenuModel } from 'src/app/core/models/menu.model';
import { ClientDetailsService } from 'src/app/core/rest-services/client-details.service';
import { MenuService } from 'src/app/core/rest-services/menu.service';
import { ConfirmDialogComponent } from 'src/app/shared/dialogs/confirm-dialog/confirm-dialog.component';
import { LoadSpinnerService } from 'src/app/shared/loaders/spinner/loadspinner.service';
import { NotificationService } from 'src/app/shared/notification/notification.service';

import { LmsModalFrameComponent } from '@lmsSharedUI';
import { SubMenuDialogComponent } from '../sub-menu-dialog/sub-menu-dialog.component';

const COLUMNS_SCHEMA = [
  {
    key: 'submenu',
    type: 'text',
    label: 'Sub Menu',
  },
  {
    key: 'component',
    type: 'text',
    label: 'Component',
  },
  {
    key: 'roles',
    type: 'text',
    label: 'Roles',
  },
  {
    key: 'isEdit',
    type: 'isEdit',
    label: 'Edit / Delete',
  },
];

@Component({
  selector: 'app-menus-dialog',
  templateUrl: './menus-dialog.component.html',
  styleUrls: ['./menus-dialog.component.scss'],
  standalone: true,
  imports: [
    LmsModalFrameComponent,
    FormsModule,
    ReactiveFormsModule,
    MdbTabsModule,
    NgIf,
    NgFor,
    MdbButtonModule,
    MdbSelectModule,
    NgSwitch,
    NgSwitchCase,
    NgSwitchDefault,
    NgClass,
  ]
})
export class MenusDialogComponent implements OnInit {
  menuModel: MenuModel = new MenuModel();
  menuForm = this.formBuilder.group({
      menu: [''],
      menu_component: [''],
      hasSubmenu: [false],
      selectedRole: [],
      trigger: [''],
      submenu: [''],
      component: [''],
      selectedJobTitles: [[]],
    });

  menu: any;
  jobTitles: any;
  color = 'primary';
  menuRole: any;
  submitted: boolean;
  isComponentRequired: boolean;
  isTriggerRequired: boolean;

  displayedColumns: string[] = COLUMNS_SCHEMA.map((col) => col.key);
  dataSource: any;
  columnsSchema: any = COLUMNS_SCHEMA;
  menuRoles: any[] = [];
  selectedMenu: any;

  constructor(
    private dialogRef: MdbModalRef<MenusDialogComponent>,
    private formBuilder: FormBuilder,
    private menuService: MenuService,
    private router: Router,
    private cs: ClientDetailsService,
    public notificationService: NotificationService,
    public dialog: MdbModalService,
    private loadingService: LoadSpinnerService
  ) {

  }

  ngOnInit(): void {
    //this.menu = this.data || (this.dialogRef as any).data || {};
    this.menuModel = this.menu || new MenuModel();
    this.menuRoles = this.menu?.menuRoles || [];

    this.cs.getAllJobTitles().subscribe((res) => {
      this.jobTitles = res;
      this.selectedMenu = this.menu || {};

      const activeRoles: any[] = [];
      for (const b of this.menu?.menuRoles || []) {
        const jobTitleId = b.jobTitle.id;
        const index = this.jobTitles.findIndex(
          (x: { id: any }) => x.id === jobTitleId
        );
        activeRoles.push(this.jobTitles[index]);
      }

      this.menuModel.selectedJobTitles = activeRoles;
    });

    this.submitted = true;

    this.menuForm.patchValue({
      menu: this.menuModel.menu,
      menu_component: this.menuModel.component,
      hasSubmenu: this.menuModel.hasSubmenu,
      selectedRole: null,
      trigger: this.menuModel.trigger,
      submenu: this.menuModel.submenus.subMenu,
      component: this.menuModel.component,
      selectedJobTitles: this.menuModel.selectedJobTitles,
    });

    if (this.menuModel.submenus.length > 0) {
      this.isComponentRequired = false;
      this.menuForm.controls['menu_component'].disable();
    } else {
      this.isComponentRequired = true;
      this.menuForm.controls['trigger'].disable();
    }

    this.dataSource = this.menuModel.submenus;

    for (const b of this.menuModel.submenus) {
      const roles: any[] = [];
      for (const role of b.submenusRoles) {
        roles.push(role.jobTitle.jobTitle);
      }
      b.roles = roles.join();
    }
  }

  modifyMenu(element: any) {
    alert('Modify menu');
    element.submenu = element.submenu.trim();
    element.component = element.component.trim();
    element.isEdit = !element.isEdit;
  }

  saveChanges() {
    if (this.menuModel.submenus == null) {
      this.menuModel.submenus = [];
    }

    if (
      this.menuModel.hasSubmenu &&
      this.menuModel.trigger &&
      this.jobTitles.length > 0 &&
      this.menuModel.menu &&
      this.menuModel.submenus.length > 0
    ) {
      this.onSaveMenus();
    } else if (
      this.menuModel.component &&
      this.jobTitles.length > 0 &&
      this.menuModel.menu
    ) {
      if (this.menuModel.component.startsWith('/')) {
        this.onSaveMenus();
      } else {
        this.notificationService.setAds([{
          title:'' ,
          body: 'Component should start with /',
          options: { closeButton: false, tapToDismiss: false, progressBar: true}
        }]);
        //this.showAlertMessage('Component should start with /', 'red-snackbar');
      }
    } else if (
      this.menuModel.hasSubmenu &&
      this.menuModel.trigger &&
      this.jobTitles.length > 0 &&
      this.menuModel.menu &&
      this.menuModel.submenus.length <= 0
    ) {
      this.notificationService.setAds([{
        title:'' ,
        body: 'Please add Submenus.',
        options: { closeButton: false, tapToDismiss: false, progressBar: true}
      }]);
      //this.showAlertMessage('Please add Submenus.', 'red-snackbar');
    }
  }

  hasSubmenuOnChangeEvent(event: any): void {
    const checked = event?.checked ?? event?.target?.checked ?? false;
    if (checked) {
      this.isComponentRequired = false;
      this.isTriggerRequired = true;
      this.menuForm.controls['menu_component'].disable();
      this.menuForm.controls['trigger'].enable();
      this.menuModel.component = '';
    } else {
      this.menuForm.controls['menu_component'].enable();
      this.menuForm.controls['trigger'].disable();
      this.menuModel.trigger = '';
      this.isComponentRequired = true;
      this.isTriggerRequired = false;
    }
  }

  onSaveMenus() {
    const savingDlg =
      this.loadingService.startLoading('Saving Menus..');

    this.selectedMenu.menuRoles = [];

    const selectedRoles: any[] = [];
    for (const role of this.menuModel.selectedJobTitles) {
      selectedRoles.push({
        id: 0,
        menu: this.selectedMenu,
        jobTitle: role,
      });
    }

    if (this.menuModel.hasSubmenu) {

      for (const b in this.menuModel.submenus) {
        const isNew = this.menuModel.submenus[b].isNew;

        if (isNew) {
          const newSubmenu = {
            submenu: this.menuModel.submenus[b].submenu,
            component: this.menuModel.submenus[b].component,
            submenusRoles: this.menuModel.submenus[b].submenusRoles
          };
          this.menuModel.submenus[b] = newSubmenu;
        }
      }
    } else {
      this.menuModel.submenus = [];
    }

    const data = {
      menu: this.selectedMenu,
      menuRoles: selectedRoles,
    };

    this.menuService.saveSubmenu(data).subscribe(() => {
      this.loadingService.stopLoading(savingDlg);
      // this.toastrService.success('','Saved successfully.');
      this.notificationService.setAds([{
        type:'success',
          title:'' ,
          body: 'Saved successfully.',
          options: { closeButton: false, tapToDismiss: false, progressBar: true}
        }]);
      void this.router.navigate(['menuAdmin']);
    });
  }

  deleteSubmenu(subMenu: any) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      modalClass: 'modal-md modal-dialog-centered d-flex',
      data: {
        title: 'Submenu Delete',
        message: 'Are you sure you want to delete?',
      },
    });

    dialogRef.onClose.subscribe((dialogResult) => {
      const confirmResult = dialogResult;

      if (confirmResult == true) {
        const SubmentDlg =
          this.loadingService.startLoading('Deleting Submenu..');

        this.menuService.deleteSubmenu(subMenu).subscribe(() => {
          this.loadingService.stopLoading(SubmentDlg);

          this.notificationService.setAds([{
              type:'success',
              title: '',
              body: 'Deleted successfully',
              options: { closeButton: false, tapToDismiss: false, progressBar: true}
          }]);
          //this.toastrService.success('','Deleted successfully.');
        });
      }
    });
  }

  async close() {
    this.dialogRef.close();
    await this.router.navigate(['menuAdmin']);
  }

  addRow() {
    const dialogRef = this.dialog.open(SubMenuDialogComponent, {
      modalClass: 'modal-md modal-dialog-centered d-flex'
    });

    dialogRef.onClose.subscribe((menu) => {
      if (menu) {
        const submenusRoles: any[] = [];
        const roles: any[] = [];

        for (const b of menu.userRoles) {
          roles.push(b.jobTitle);
          submenusRoles.push({
            jobTitle: { id: b.id },
            submenu: menu
          });
        }

        const newMenu = {
          id: Date.now(),
          submenu: menu.submenu,
          component: menu.component,
          isEdit: false,
          isNew: true,
          submenusRoles: submenusRoles,
          roles: roles.join()
        }

        this.dataSource = [newMenu, ...this.dataSource];
        this.menuModel.submenus = this.dataSource;
      }
    });
  }

  editSubmenu(element: any) {
    const dialogRef = this.dialog.open(SubMenuDialogComponent, {
      modalClass: 'modal-md modal-dialog-centered d-flex',
      data: element
    });

    dialogRef.onClose.subscribe((menu) => {
      if (menu) {
        const submenusRoles: any[] = [];
        const roles:any[] = [];

        for (const b of menu.userRoles) {
          roles.push(b.jobTitle);
          submenusRoles.push({
            jobTitle: { id: b.id },
            sub_menu_id: menu.id,
          });
        }

        menu.submenusRoles = submenusRoles;
        menu.roles = roles.join();
      }
    });
  }

  removeRow(element: any) {
    this.dataSource = this.dataSource.filter(
      (u: { id: number }) => u.id !== element.id
    );
    this.deleteSubmenu(element);
    this.menuModel.submenus = this.dataSource;
  }

  removeTrailingSpaces(element: any) {
    element.submenu = element.submenu.trim();
    element.component = element.component.trim();
  }
}
